/* !
 * recipesDetail.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const FAVO_MAX = 50;
	const a = 'is-active';
	const v = 'is-visible';
	const thisKey = FUNCTIONS.va.pathname.split('/')[2].replace(/detail-/, '').replace(/\.html/, '');

	// お気に入り処理
	const setFavoDetail = () => {
		let add = document.querySelector('.js-favorite_add');
		let del = document.querySelector('.js-favorite_delete');
		let chip = document.querySelector('.recipe-detail-favoChip');

		// お気に入り商品かチェック
		let favoFlg;
		for (let i in localStorage) {
			if (i.indexOf('pokkasapporoFavoriteRecipeList-') !== -1) {
				if (i.replace(/pokkasapporoFavoriteRecipeList-/, '') === thisKey) {
					favoFlg = true;
				}
			}
		}
		(!favoFlg) ? add.classList.add(a) : del.classList.add(a);

		// お気に入り追加
		add.addEventListener('click', () => {
			let favoStorage = [];
			for (let i in localStorage) {
				if (i.indexOf('pokkasapporoFavoriteRecipeList-') !== -1) { favoStorage.push(i); }
			}
			if (favoStorage.length >= FAVO_MAX) {
				// すでに50件登録がある場合はチップ表示
				chip.classList.add(a);
				setTimeout(() => { chip.classList.add(v); });
				setTimeout(() => {
					chip.classList.remove(v);
					setTimeout(() => { chip.classList.remove(a); }, 100);
				}, 3000);
			} else {
				let favoDatetime = new Date();
				favoDatetime = `${favoDatetime.getFullYear()}/${('0' + (favoDatetime.getMonth() + 1)).slice(-2)}/${(('0' + (favoDatetime.getDate())).slice(-2))} ` +
					`${('0' + (favoDatetime.getHours())).slice(-2)}:${('0' + (favoDatetime.getMinutes())).slice(-2)}:${('0' + (favoDatetime.getSeconds())).slice(-2)}`;
				localStorage.setItem('pokkasapporoFavoriteRecipeList-' + thisKey, favoDatetime);
				add.classList.remove(a);
				del.classList.add(a);
				FUNCTIONS.setFavoriteCount();
			}
		});

		// お気に入り削除
		del.addEventListener('click', () => {
			localStorage.removeItem('pokkasapporoFavoriteRecipeList-' + thisKey);
			del.classList.remove(a);
			add.classList.add(a);
			FUNCTIONS.setFavoriteCount();
		});
	};
	setFavoDetail();

	// 使用商品 空のリンク消し込み
	const removeUseProdLink = () => {
		if (document.querySelectorAll('.recipe-detail-useProd .__item').length) {
			document.querySelectorAll('.recipe-detail-useProd .__links li').forEach(ele => {
				if (!ele.getElementsByTagName('a').length) { ele.remove(); }
			});
		}
	};
	removeUseProdLink();

	// おすすめレシピ 最大4件 SPのみスライダー
	const recommendRecipeSlider = () => {
		fetch(`/ajax/recipes/info/${thisKey}.json`).then(response => response.json()).then(data => {
			if (data.recipe_info.length) {
				let recipeInfo = data.recipe_info[0].cf_r_category;
				let recipeProd = data.recipe_info[0].cf_r_recipe_use_product;
				let jsonParam = '?';

				recipeInfo.forEach(ele => {
					if (ele.cf_rc_group_code === 'main_foods') {
						jsonParam += 'main_foods=' + ele._key + '&';
					} else if (ele.cf_rc_group_code === 'type') {
						jsonParam += 'type=' + ele._key + '&';
					}
				});
				recipeProd.forEach(ele => {
					jsonParam += 'product_key=' + ele._key + '&';
				});
				jsonParam = jsonParam.slice(0, -1);

				fetch(`/ajax/recipes/recommend/${thisKey}.json${jsonParam}`).then(response => response.json()).then(data => {
					if (data.recipes_list.length) {
						let recentHTML = '';
						data.recipes_list.forEach(ele => {
							recentHTML += `<li class="__item splide__slide"><a href="${ele.rt_cf_r_href.href}" class="mod-boxLink01">` +
								`<figure><div><img src="${ele.rt_cf_r_img.src}" alt="" loading="lazy" width="596" height="369" class=""></div>` +
								`<figcaption class="mod-link01"><span>${ele.rt_cf_r_recipe_title}</span></figcaption></figure></a></li>`;
						});
						document.querySelector('.recipe-detail-recommend .splide__list').innerHTML = recentHTML;

						let recipeSlider = document.querySelector('.recipe-detail-recommend-slider.splide');
						let recipeList = recipeSlider.querySelectorAll('.splide__slide');
						const pagination =
							((FUNCTIONS.va.window.width < FUNCTIONS.va.device.desktop && FUNCTIONS.va.window.width >= FUNCTIONS.va.device.sp && recipeList.length > 3) ||
								(FUNCTIONS.va.window.width < FUNCTIONS.va.device.desktop && recipeList.length > 2)) ? true : false;

						const splide_recommend = new Splide('.recipe-detail-recommend-slider.splide', {
							type: 'slide',
							perPage: 4,
							autoplay: false,
							speed: 500,
							arrows: false,
							pagination: false,
							paginationKeyboard: true,
							flickPower: 200,
							waitForTransition: false,
							gap: '20px',
							breakpoints: {
								768: {
									perPage: 3,
									perMove: 3,
									arrows: pagination,
									pagination: pagination,
								},
								640: {
									perPage: 2,
									perMove: 2,
									gap: '15px'
								},
							}
						});
						splide_recommend.mount();

						// スライダーの矢印位置調整
						let updateArrowPosition = (_slide, _arrows) => {
							if (_slide) {
								let imageHeight = _slide.offsetHeight;
								_arrows.forEach(arrow => {
									arrow.style.top = `${imageHeight / 2}px`;
								});
							}
						};
						updateArrowPosition(recipeSlider.querySelectorAll('.splide__slide img')[0], recipeSlider.querySelectorAll('.splide__arrow'));

						window.addEventListener('resize', () => {
							updateArrowPosition(recipeSlider.querySelectorAll('.splide__slide img')[0], recipeSlider.querySelectorAll('.splide__arrow'));
						});
					} else {
						document.querySelector('.recipe-detail-recommend').remove();
					}
				});
			} else {
				document.querySelector('.recipe-detail-recommend').remove();
			}
		});
	};
	recommendRecipeSlider();


	// 定番レシピ 空のアイテムを消し込み
	document.querySelectorAll('.recipe-usual-slider li').forEach(ele => {
		if (!ele.getElementsByTagName('a').length) { ele.remove(); }
	});
	// 定番レシピ スライダー
	const usualRecipeSlider = document.querySelector('.recipe-usual-slider.splide');
	if (usualRecipeSlider) {
		const splide_usualRecipe = new Splide('.recipe-usual-slider.splide', {
			type: 'slide',
			perPage: 4,
			autoplay: false,
			speed: 500,
			arrows: true,
			pagination: true,
			paginationKeyboard: true,
			flickPower: 200,
			waitForTransition: false,
			gap: '32px',
			focus: 'left',
			omitEnd: true,
			breakpoints: {
				768: {
					perPage: 3,
				},
				640: {
					perPage: 2,
					gap: '15px'
				},
			}
		});
		splide_usualRecipe.mount();
		// スライダーの矢印位置調整
		const updateArrowPosition = (_slide, _arrows) => {
			if (_slide) {
				const imageHeight = _slide.offsetHeight;
				_arrows.forEach(arrow => {
					arrow.style.top = `${imageHeight / 2}px`;
				});
			}
		};
		updateArrowPosition(usualRecipeSlider.querySelectorAll('.splide__slide img')[0], usualRecipeSlider.querySelectorAll('.splide__arrow'));
		window.addEventListener('resize', updateArrowPosition(usualRecipeSlider.querySelectorAll('.splide__slide img')[0], usualRecipeSlider.querySelectorAll('.splide__arrow')));
	}


	// 最近見たレシピ登録
	const setRecentItemStorage = () => {
		let viewDatetime = new Date();
		viewDatetime = `${viewDatetime.getFullYear()}/${('0' + (viewDatetime.getMonth() + 1)).slice(-2)}/${(('0' + (viewDatetime.getDate())).slice(-2))} ` +
			`${('0' + (viewDatetime.getHours())).slice(-2)}:${('0' + (viewDatetime.getMinutes())).slice(-2)}:${('0' + (viewDatetime.getSeconds())).slice(-2)}`;
		localStorage.setItem('pokkasapporoRecentRecipeList-' + thisKey, viewDatetime);
	};
	setRecentItemStorage();

	// 最近見たレシピ出力 最大4件 SPのみスライダー
	const setRecentItemSlider = () => {
		let favoStorage = [];
		for (let i in localStorage) {
			if (i.indexOf('pokkasapporoRecentRecipeList-') !== -1) { favoStorage.push(i); }
		}
		if (favoStorage.length) {
			let recipeParams = '';
			favoStorage.forEach(ele => {
				recipeParams += `&p_recipe_id=${ele.replace(/pokkasapporoRecentRecipeList-/, '')}`;
			});
			recipeParams = recipeParams.slice(1);

			fetch(`/ajax/recipes/detail/data.json?${recipeParams}`).then(response => response.json()).then(data => {
				if (data.rt_bn_recipe_detail.length) {
					let recipeData = data.rt_bn_recipe_detail;
					recipeData.forEach(ele => {
						ele.datetime = localStorage.getItem(`pokkasapporoRecentRecipeList-${ele._key}`);
					});
					recipeData.sort((x, y) => {
						let xDate = x['datetime'];
						let yDate = y['datetime'];
						if (xDate > yDate) return -1;
						if (xDate < yDate) return 1;
						return 0;
					});
					if (recipeData.length > 4) {
						localStorage.removeItem(`pokkasapporoRecentRecipeList-${recipeData[4]._key}`);
						recipeData.pop();
					}
					let recentHTML = '';
					recipeData.forEach(ele => {
						recentHTML += `<li class="__item splide__slide"><a href="${ele.rt_cf_r_recipe_href.href}" class="mod-boxLink01">` +
							`<figure><div><img src="${ele.rt_cf_r_img.src}" alt="" loading="lazy" width="596" height="369" class=""></div>` +
							`<figcaption class="mod-link01"><span>${ele.rt_cf_r_title.content}</span></figcaption></figure></a></li>`;
					});
					document.querySelector('.recipe-detail-recent .splide__list').innerHTML = recentHTML;

					let recentRecipeSlider = document.querySelector('.recipe-detail-recent-slider.splide');
					let pagination =
						((FUNCTIONS.va.window.width < FUNCTIONS.va.device.desktop && FUNCTIONS.va.window.width >= FUNCTIONS.va.device.sp && recipeData.length > 3) ||
							(FUNCTIONS.va.window.width < FUNCTIONS.va.device.desktop && recipeData.length > 2)) ? true : false;
					let splide_recent = new Splide('.recipe-detail-recent-slider.splide', {
						type: 'slide',
						perPage: 4,
						autoplay: false,
						speed: 500,
						arrows: false,
						pagination: false,
						paginationKeyboard: true,
						flickPower: 200,
						waitForTransition: false,
						gap: '20px',
						breakpoints: {
							768: {
								perPage: 3,
								perMove: 3,
								arrows: pagination,
								pagination: pagination,
							},
							640: {
								perPage: 2,
								perMove: 2,
								gap: '15px'
							},
						}
					});
					splide_recent.mount();

					// スライダーの矢印位置調整
					let updateArrowPosition = (_slide, _arrows) => {
						if (_slide) {
							let imageHeight = _slide.offsetHeight;
							_arrows.forEach(arrow => {
								arrow.style.top = `${imageHeight / 2}px`;
							});
						}
					};
					updateArrowPosition(recentRecipeSlider.querySelectorAll('.splide__slide img')[0], recentRecipeSlider.querySelectorAll('.splide__arrow'));
					window.addEventListener('resize', updateArrowPosition(recentRecipeSlider.querySelectorAll('.splide__slide img')[0], recentRecipeSlider.querySelectorAll('.splide__arrow')));
				}
			});
		}
	};
	setRecentItemSlider();


	const setLDJSON = () => {
		let appendSrc =
		'{"@context": "http://schema.org/", "@type": "Recipe",' +
		'"name": "' + document.querySelector('.t-h1_detail').textContent + '",' +
		'"image": "https://www.pokkasapporo-fb.jp' + document.querySelector('.recipe-detail-mainImg .rt_cf_r_img').getAttribute('src') + '",';

		if (document.querySelector('.rt_cf_r_cook_time').length) {
			let totalTimeStr = document.querySelector('.rt_cf_r_cook_time').textContent;
			totalTimeStr = totalTimeStr.replace(/時間/, 'H').replace(/分/, 'M').replace(/\+/, '');
			appendSrc += '"totalTime": "PT' + totalTimeStr + '",';
		}
		appendSrc +=
		'"recipeYield": "' + document.querySelector('.rt_cf_r_serves').textContent.replace(/（/, '').replace(/）/, '') + '",' +
		'"nutrition": { "calories": "' + document.querySelector('.rt_cf_r_energy').textContent + '" },';

		appendSrc += '"recipeIngredient": [';
		document.querySelectorAll('.rt_cf_r_ingredients').forEach(val => {
			appendSrc += '"';
			if (val.querySelector('.rt_cf_r_ingredients_food_group')) {
				appendSrc += val.querySelector('.rt_cf_r_ingredients_food_group').textContent;
			}
			appendSrc += val.querySelector('.rt_cf_r_ingredients_food_name').textContent + ' ' + val.querySelector('.rt_cf_r_ingredients_food_amount').textContent + '",';
		});
		appendSrc = appendSrc.slice(0, -1);
		appendSrc += '],';

		// Howto
		appendSrc += '"recipeInstructions": [';
		if (document.getElementsByClassName('recipe-detail-preparation').length) {
			appendSrc += '{ "@type": "HowToStep", "text": "【下準備】' + document.querySelector('.recipe-detail-preparation p').textContent + '" },';
		}
		document.querySelectorAll('.cf_r_direction').forEach((val, idx) => {
			var num = idx + 1;
			appendSrc += '{ "@type": "HowToStep", "text": "（' + num + '）' + val.querySelector('.rt_cf_r_direction_cf_rpt_explanation').textContent + '" },';
		});
		appendSrc = appendSrc.slice(0, -1);
		appendSrc += ']}';

		document.querySelector('.jsonld-script').innerHTML = appendSrc;
	};
	setLDJSON();

})(window.FUNCTIONS);